/** @format */

import React, { ElementType, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store/store";
import { hasBusinessSession } from "../../redux/services/businessAuthService";

interface BusinessProtectedRouteProps {
    component: ElementType;
    [key: string]: any;
}

/**
 * Route guard for the Collect *business* product. Gates access on the
 * dedicated BusinessUser session (`b_*` tokens) — completely independent of the
 * circle `ProtectedRoute`. Unauthenticated users are redirected to the Collect
 * sign-in page.
 */
export const BusinessProtectedRoute: React.FC<BusinessProtectedRouteProps> = ({
    component: Component,
    ...rest
}) => {
    const navigate = useNavigate();
    const isAuthenticated = useSelector(
        (state: RootState) => state.businessAuth.isAuthenticated,
    );

    // Fall back to localStorage so a hard refresh (before the slice rehydrates
    // its derived flag) still recognises an active session.
    const authed = isAuthenticated || hasBusinessSession();

    useEffect(() => {
        if (!authed) {
            navigate("/collect/sign-in", { replace: true });
        }
    }, [authed, navigate]);

    return authed ? <Component {...rest} /> : null;
};
